import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/orderDocumentsInfo', request)
}

export {get}
